<template>
	<div>
		<h6 style="font-weight: 400; margin: 0px !important; padding: 0px !important">
		Giriş Adedi:	{{ params.data.QENTRY }} <br/>
		Çıkış Adedi:	{{ params.data.QEXIT }} <br/>
		Depo:	{{ params.data.QDEPOT }} <br/>
		{{ params.data.STOCKNAME }} <br/>	{{ params.data.STOCKNO }} 

		</h6>
	</div>
</template>
<script>
export default {
	data() {
		return {
			VALUE: "",
		};
	},
	created() {
		this.VALUE = this.params.value;
	},
};
</script>
		